// The Branch AS er avviklet. Nettsiden står videre som et arkiv.
// Endre årstallene her, så oppdateres banner, forside, om oss og footer.
export const FOUNDED_YEAR = 2021;
export const CLOSED_YEAR = 2025;
export const ACTIVE_YEARS = `${FOUNDED_YEAR}–${CLOSED_YEAR}`;
